import React, { useEffect, useState } from "react"

import "./ListOfSales.css"
import "../../Components/Commons/Commons.css"

import SidebarMenu from "../../Components/Sidebar/Sidebar"
import AntDTable from "../../Components/AntDTable/AntDTable"
import SelectField from "../../Components/Commons/Forms/SelectField";
import { DATE_FORMAT } from "../../Utils/dateFormat";

import { getInventories } from "../../Components/Helpers/API/InventoryApi/InventoryApi"
import { DatePicker } from "antd"
import { getInventoriesLogs } from "../../Components/Helpers/API/InventoryApi/InventoryApi"
import { formatDateWithTime, formatDateYMD } from "../../Components/Helpers/Utilities/Common"

const { RangePicker } = DatePicker

function Inventories() {
  const [data, setData] = useState([])
  const [showLoader, setShowLoader] = useState(false)
  const [dateRange, setDateRange] = useState([])
  const [filterItem, setFilterItem] = useState("")
  const [inventories, setInventories] = useState([])

  // Function get inventories API
  async function fetchInventoriesLogs() {
    setShowLoader(true)
    const res = await getInventoriesLogs({
      date_from: dateRange?.length > 0 ? formatDateYMD(dateRange[0]) : "",
      date_to: dateRange?.length > 1 ? formatDateYMD(dateRange[1]) : "",
      inventory_id: filterItem?.target?.value ?  filterItem?.target?.value : ""

    })

    if (res.data) {
      var _parsed = res.data.data.map((inventory) => ({
        ...inventory,
        date: formatDateWithTime(inventory.added_on),
        remarks : inventory.remarks !== "undefined" ? inventory.remarks : ""
      }))
      setData(_parsed)
    }
    setShowLoader(false)
  }

  //get Inventories API
  async function fetchInventories() {
    const res = await getInventories()

    if (res.data) {
      var _parsed = res.data.data.map((inventory) => ({
        ...inventory,
        value: inventory.id,
        label: inventory.item,
      }))
      setInventories(_parsed)
    }
  }

  useEffect(() => {
    fetchInventories()
  }, [])

  useEffect(() => {
    fetchInventoriesLogs()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateRange, filterItem])

  // function getting the date
  const onDateChange = (dateString) => {
    setDateRange(dateString)
  }

  // function getting the date
  const onFilterItems = (item) => {
    setFilterItem(item)
  }

  return (
    <div className="App">
      <SidebarMenu active={"Pharmacy"} active_sub={"Inventory Logs"} />
      <div className="col p-5 pt-4 manager-container all-container">
        <div className="row pt-2 p-3">
          <div className="col font-big title-2 all-patient">
            Inventory Logs
          </div>
        </div>
        <div className="my-4 row">
          <div className="col">
            <span>Filter by: </span>
            <RangePicker format={DATE_FORMAT} onChange={onDateChange} />
          </div>
          <div className="col-4">
            {/* <span>Type:</span> */}
            <SelectField
              // formLabel={`Type`}
              name="type"
              size={`sm`}
              placeholder={"SELECT"}
              options={[
                { value: "", label: "--Select Type--" },
                ...inventories
              ]}
              // value={addAdmissionData.health_condition}
              onChange={onFilterItems}
              // disabled={isClicked}
            />
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-sm-12 all-table">
            <AntDTable
                tableHeaders={[
                    "DATE", 
                    "ITEM NAME", 
                    "TYPE",
                    "PREVIOUS QUANTITY", 
                    "UPDATED QTY",
                    "REMARKS",
                    "ADDED BY",
                ]}
                headerSelector={[
                    "date", 
                    "item", 
                    "action",
                    "old_stock_qty", 
                    "updated_stock_qty",
                    "remarks",
                    "added_by_name",
                ]}
                tableData={data}
            //   ActionBtn={(row) => ActionBtn(row)}
                loading={showLoader}
            //   withAction={true}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Inventories
